import Button from '@mui/material/Button';
import styled from 'styled-components';
import { makeStyles } from '@mui/styles';

export const Root = styled.div`
  position: relative;
  display: flex;
  flex: 1 1 auto;
`;

export const TopPanel = styled.div`
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;

  & > *:not(first-child) {
    margin-left: 5px;
  }
  width: 100%;
  height: 35px;
`;

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  marginLeftButton: {
    marginLeft: theme.spacing(1),
    float: 'right'
  },
  toRight: {
    float: 'right'
  },
  toLeft: {
    float: 'left',
    lineHeight: '36px'
  },
  yearSelector: {
    float: 'right',
    marginLeft: '10px'
  }
}));

export const ButtonContainer = styled.div`
`;

export const HomePage = styled.div`
  flex: 1 1 auto;
  ${({ noPadding }) => !noPadding && 'padding: 10px 20px;'}
  ${({ fullHeight }) => fullHeight && 'height: calc(100vh - 48px); display: flex; flex-direction: column;'}
`;

export const PageTop = styled.div`
  padding: 10px 20px;
  border-top: 1px solid #ccc !important;
`;

export const HomeButton = styled(Button).attrs({
  variant: 'outlined',
  color: 'primary',
})`
  text-transform: none !important;
  height: 30px !important;
`;

export const MainButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary',
})`
  text-transform: none !important;
  height: 30px !important;
`;

export const ButtonSpacer = styled.span`
  ${({ withBorder }) => withBorder
    ? 'border-left: 1px solid rgba(0,0,0,.1); margin: 0 5px;'
    : 'margin-left: 5px;'}
  height: 100%;
`;
